import { Space } from "@mantine/core";
import { CTABanner } from "../CTABanner/CTABanner";
import { CTABannerSingle } from "../CTABannerSingle/CTABannerSingle";
import { CTAVideoBanner } from "../CTAVideoBanner/CTAVideoBanner";
import { CommunityReviews } from "../CommunityReviews/CommunityReviews";
import { FeatureCardList } from "../FeatureCardList/FeatureCardList";
import { HeroTitle } from "../HeroTitle/HeroTitle";
import { PricingModule } from "../PricingModule/PricingModule";
import { WelcomeBanner } from "../WelcomeBanner/WelcomeBanner";

export default function BodyContent({logged_in}: { logged_in: boolean }): React.JSX.Element {
  return (
    <>
      <HeroTitle />
      <Space h="xl" id="pricing" />
      <CTABanner />
      <Space h="xl" />
      <WelcomeBanner />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" id="features" />
      <Space h="xl" />
      <FeatureCardList />
      {/* <Space h="xl" />
      <CTAVideoBanner /> */}
      <Space h="xl" />
      {/* <Space h="xl" id="community" />
      <Space h="xl" />
      <CommunityReviews />
      <Space h="xl" />
      <Space h="xl" /> */}
      <Space h="xl" id="pricing2" />
      <Space h="xl" />
      <PricingModule />
      <Space h="xl" />
      <Space h="xl" />
    </>
  );
}
